import { Login } from "../../Components/Login&SignUp/Login";

const LoginPage = () => {
  return (
    <div>
      <Login />
    </div>
  );
};

export default LoginPage;
